<app-topbar  #cat></app-topbar>



<div [class.catopened]="cat.showCategories" class="carte">
	<img *ngIf="cat.cat=='softs'" src="assets/img/01_CARTE-DIGITALE_captain-pub_SOFTS.jpg" alt="">
    <img *ngIf="cat.cat=='bieres'" src="assets/img/02_CARTE-DIGITALE_captain-pub_BIERES.jpg" alt="">
    <img *ngIf="cat.cat=='aperitif'" src="assets/img/03_CARTE-DIGITALE_captain-pub_vertical_APERITIFS.jpg" alt="">
  	<img *ngIf="cat.cat=='default'" src="assets/img/09_CARTE-DIGITALE_captain-pub_vertical_MENU.jpg" alt="">
    <img *ngIf="cat.cat=='vins'" src="assets/img/05_CARTE-DIGITALE_captain-pub_vertical_VINS.jpg" alt="">
    <img *ngIf="cat.cat=='digestif'" src="assets/img/06_CARTE-DIGITALE_captain-pub_vertical_DIGESTIFS.jpg" alt="">
    <img *ngIf="cat.cat=='specialites_chaudes'" src="assets/img/07_CARTE-DIGITALE_captain-pub_SPECIALITES-CHAUDES.jpg" alt="">
    <img *ngIf="cat.cat=='cocktail'" src="assets/img/08_CARTE-DIGITALE_captain-pub_vertical_COCKTAILS.jpg" alt="">
    <img *ngIf="cat.cat=='whisky'" src="assets/img/11_CARTE_DIGITALE_captain-pub_WHISKY.jpg" alt="">
    <img *ngIf="cat.cat=='rhums'" src="assets/img/12_CARTE_DIGITALE_captain-pub_RHUMS.jpg" alt="">
</div>



<!--img class="carte" src="assets/img/carte2.jpg" alt="" -->

<app-navbar *ngIf="id !== null"></app-navbar>

